import React, { PureComponent } from 'react';
import Toggle from 'widgets/Toggle/Toggle';

const getValueForCondition = (values, conditionId) => {
  const condition = values.find(v => v.ConditionID === conditionId);

  return condition ? condition.ConditionSelected : 0;
};
export default class FoodProfileToggles extends PureComponent {
  static defaultProps = {
    conditions: [],
  };

  render() {
    const {
      conditions,
      values,
    } = this.props;

    return (
      <div className="foodProfileToggles">
        {conditions.map((condition) =>
          <Toggle
            id={`field_${condition.ConditionID}`}
            key={`key_${condition.ConditionID}`}
            label={condition.ConditionName}
            name={condition.ConditionID}
            checked={getValueForCondition(values, condition.ConditionID)}
            onChange={(e) => this.props.onChange(condition.ConditionID, Number(e.target.checked))}
          />
        )}
      </div>
    );
  }
}
